export const ar_DZ = {
    LEFT: 'الأيسر: التحرك اليوم السابق.',
    RIGHT: 'اليمين: الانتقال إلى اليوم التالي.',
    DOWN: 'أسفل: الانتقال إلى الصف التالي.',
    UP: 'Up: الانتقال إلى الصف السابق.',
    PGUP: 'PgUp: الانتقال إلى الشهر السابق.',
    PGDOWN: 'PgDown: الانتقال إلى الشهر المقبل.',
    HOME: 'الوطن: الانتقال إلى السنة السابقة.',
    END: 'End: الانتقال إلى العام المقبل.',
    ESC: 'Esc/اليوم/إغلاق: إغلاق التقويم.',
    TITLE: 'لوحة المفاتيح تعليمات'
};
